<template>
  <div id="evaluate-page">
    <topNav :tit="'全部评价'"></topNav>
    <ul>
      <li v-for="item in evList">
        <div class="ev-title">
          <h2>顾客{{item.nikeName}}对{{item.guideName}}的评价</h2>
          <span>{{item.evalTime | formatMonthDay}}</span>
        </div>
        <div class="ev-content">
          {{item.content}}
        </div>
      </li>
    </ul>
    <div class="sn-loading-type" v-show="evList.length > 0">
      <span class="sn-pull-loading hide">上拉精彩无限</span>
      <div class="sn-end-loading hide"><span>没有更多了</span></div>
    </div>
    <div class="loadmore" data-loaded=""></div>
    <input type="hidden" id="pagename" value="pgcate=10009;tag=100043;pgtitle=身边苏宁-评价列表页">
  </div>
</template>
<script>
  //导入模块
  import CONF from '@/app.conf.json';
  import Server from '../services/Entrance';
  import {Util} from '../commons/util'
  
  import topNav from  '@/components/commons/_topNav'
  import _ from 'lodash';

  export default {
    name: 'Evaluate',
    data () {
      return {
        evList: [],
        storeCode: '',
        pageNumber: 1,
        totalCount: 0,
        loadable: false
      }
    },
    // 生命周期钩子
    mounted () {
    	
      document.title="全部评价";
      
      let _this = this,
        urlParams = _this.$route.params;

      _this.storeCode = urlParams.storeCode;
      
      // lazyload
      let $loadMore = $(".loadmore"),
        $pullLoading = $(".sn-pull-loading"),
        $snEndLoading = $(".sn-end-loading");
      
      Server.common.queryEvaluate(_this.storeCode, _this.pageNumber).then(data => {

        _this.evList = data.evaluateList;
        _this.loadable = true;
        _this.totalCount = data.totalCount;
        
        if(_this.evList.length === _this.totalCount ){
        	
          $pullLoading.hide();
          $snEndLoading.show();
          $loadMore.attr("data-loaded", "done");
          
        } else {

          $loadMore.lazyload(function (el) {
    
            if (!_this.loadable) {
      
              return;
            }
    
            if (_this.evList.length >= _this.totalCount) {
              $pullLoading.css('display', 'none');
              $snEndLoading.css('display', 'block');
              el.attr("data-loaded", "done");
      
              return;
            }
    
            _this.loadable = false;
    
            _this.pageNumber++;
    
            Server.common.queryEvaluate(_this.storeCode, _this.pageNumber).then(data => {
      
              let evaluateList = data.evaluateList;
      
              console.log('evaluateList', data);
      
              _this.evList = _this.evList.concat(evaluateList);
              _this.loadable = true;
            });
    
            $pullLoading.show();
          });
        }
      })

      

      
    },
    components: {
      topNav
    },
    watch: {

    },
    methods: {

    }
  }
</script>
<style scoped>
  #evaluate-page {
     background: #ffffff;
    .nav{
      background: #ff9900;
    }
    .sn-nav-back{
      z-index: 999;
      border-bottom: 0;
      position: relative;
      height: 1.76rem;
      line-height: 1.76rem;
      font-size: 34px;
      width: 100%;
      a{
        height: 1.76rem;
      }
    }
    .sn-nav-back:before{
      border: solid #fff;
      border-width: 3px 0 0 3px;
      -webkit-transform: rotate(-45deg);
      left: .56rem;
    }
    .title{
      font-family:PingFangSC-Medium;
      text-align: center;
      color:#ffffff;
    }

    .loadmore {
      /*height: 1px;*/
    }

    ul {
      /*border-top: 20px solid #f2f2f2;*/
    }

    .ev-title {
      margin-bottom: 10px;
      height: auto;
      overflow: hidden;
      font-family: "PingFangSC-Regular";
      font-size: 24px;
      color: #999999;
      letter-spacing: 0;

      span {
        float: right;
      }
      h2 {
        float: left;
      }
    }

    li {
      border-bottom: 20px solid #f2f2f2;
      padding: 20px;
      font-family: "PingFangSC-Regular";
      font-size: 28px;
      color: #222222;
      letter-spacing: 0;
    }
    .sn-loading-type{
      background: #f2f2f2;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Evaluate.vue